// frontend\src\pages\Calculators\components\VolumeMixer\constants.js
export const DEFAULT_VALUES = {
  part1: '1',
  part2: '1',
  part3: '0',
  finalVolume: '500'
};

export const PART_LABELS = [
  { id: 'part1', label: 'Часть 1' },
  { id: 'part2', label: 'Часть 2' },
  { id: 'part3', label: 'Часть 3' }
];